export const storageUnits = [
  {
    slug: "atelier-louver",
    index: "01",
    name: "Atelier Louver",
    finish: "Solid Wood",
    layout: "Louvered storage wall with bench",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/q0y85cem_IMG_6780.jpg",
    alt: "Atelier Louver solid wood louvered storage wall with bench and open cubbies",
    description: "Atelier Louver is solid wood at its most honest — real timber louvres that let the wall breathe, hand-finished so every slat carries the grain and warmth of natural oak. A built-in bench, open cubbies and generous shutters turn an entryway into a ritual of arriving home.",
    materials: ["Solid timber louvered shutters", "Hand-finished natural sealant", "Dark metal hardware", "Built-in bench with open cubbies"],
  },
  {
    slug: "ebon-grain",
    index: "02",
    name: "Ebon Grain",
    finish: "Veneer + Solid Wood",
    layout: "Statement sideboard cabinet",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/n6vhirke_IMG_6781.jpg",
    alt: "Ebon Grain sideboard in dark solid wood with dramatic figured veneer panels",
    description: "Ebon Grain is where craft becomes art — a dark solid wood frame cradling figured veneer panels whose grain runs like ink in water. The pairing of veneer and solid wood gives you the drama of rare timber with the strength and honesty of real joinery beneath.",
    materials: ["Solid hardwood frame, ebonised finish", "Figured veneer feature panels", "Soft-close drawers and shutters", "Hand-rubbed matte polish"],
  },
  {
    slug: "salon-bleu",
    index: "03",
    name: "Salon Bleu",
    finish: "PU + Glass",
    layout: "Bar and crockery cabinet",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/xohkw2v0_IMG_6808.JPG",
    alt: "Salon Bleu navy PU bar cabinet with arched glass display and fluted shutters",
    description: "Salon Bleu is the evening cabinet — midnight PU sprayed to a deep satin calm, with arched glass displays that let crystal and porcelain glow against marble. Fluted base shutters hide the everyday, while brass lines trace every edge like jewellery on midnight blue.",
    materials: ["Sprayed PU fronts, deep satin navy", "Arched glass display shutters", "Fluted base panelling", "Brass bar handles and trim"],
  },
  {
    slug: "shale",
    index: "04",
    name: "Shale",
    finish: "Membrane",
    layout: "Mudroom wall with bench",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/rtbmzzf3_IMG_6784.jpg",
    alt: "Shale membrane mudroom storage wall in mushroom grey with bench",
    description: "Shale turns the hardest-working wall of the home into the calmest — membrane-pressed shutters in soft mushroom grey, wrapped seamlessly over every frame so rain, mud and daily traffic never leave a mark. A long bench, open basket cubbies and quiet brass complete the ritual of coming home.",
    materials: ["Membrane-pressed framed shutters", "Seamless wrapped edges, moisture-safe", "Built-in bench with basket cubbies", "Aged brass knobs and latches"],
  },
  {
    slug: "sage-manor",
    index: "05",
    name: "Sage Manor",
    finish: "Solid Wood, Vintage",
    layout: "Vintage hallway storage with boot room",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/bheanafj_IMG_6783.jpg",
    alt: "Sage Manor vintage solid wood mudroom with oak bench and hooks",
    description: "Sage Manor is vintage craft for modern mornings — solid wood framed shutters in a heritage sage, paired with a raw oak bench, iron hooks and a proper boot room below. Every panel is joined the old way and finished by hand, so the hallway feels collected rather than installed.",
    materials: ["Solid wood framed shutters, heritage sage", "Raw oak bench and shelving", "Cast-iron hooks and black bar pulls", "Hand-finished vintage sealant"],
  },
  {
    slug: "ivory-hall",
    index: "06",
    name: "Ivory Hall",
    finish: "PU + Lamitex",
    layout: "Entryway storage with window bench",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/kf7ojlqp_IMG_6786.jpg",
    alt: "Ivory Hall entryway storage in cream PU with Lamitex oak shelf and cushioned bench",
    description: "Ivory Hall greets guests with light — cream PU framed fronts that stay crisp and wipe-clean, warmed by a Lamitex oak shelf and woven textures. A cushioned bench, basket drawers and gallery hooks make the first metre of the home feel like an embrace.",
    materials: ["Sprayed PU framed fronts, ivory satin", "Lamitex laminate oak display shelf", "Cushioned bench with basket drawers", "Brass cube knobs and hooks"],
  },
];
